import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { getUnreadCoachMessageCount } from '../services/messagesService';

// Shared by BottomNav.jsx and DesktopTopNav.jsx so the two nav surfaces read
// the same badge instead of each fetching it independently.
export function useUnreadMessageCount(refreshKey) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || cancelled) return;
      try {
        const c = await getUnreadCoachMessageCount(user.id);
        if (!cancelled) setCount(c);
      } catch (e) {
        console.error('Failed to load unread message count:', e);
      }
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);

  return count;
}
